"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionType = exports.RenewalAction = exports.Entitlement = exports.Status = exports.BillingStatus = exports.Lifecycle = void 0;
var Lifecycle;
(function (Lifecycle) {
    /**
     * The subscription is still active and can be managed.
     * e.g. the subscription can be upgraded, downgraded, cancelled, renewed,
     * resolve billing issues, etc.
     */
    Lifecycle["Active"] = "Active";
    /**
     * The subscription is in its final terminated state. It can no longer
     * be resumed. A new subscription must be created to replace it.
     *
     * The user is never entitled to use the subscription when in the Expired state.
     */
    Lifecycle["Terminated"] = "Terminated";
})(Lifecycle = exports.Lifecycle || (exports.Lifecycle = {}));
/**
 * Has the current billing period been paid for yet, or not?
 *
 * If not, it indicates the user has a billing issue to resolve.
 */
var BillingStatus;
(function (BillingStatus) {
    /**
     * There are no billing issues.
     * - the current billing period has been paid, or
     * - the subscription has terminated.
     */
    BillingStatus["Ok"] = "Ok";
    /**
     * The current billing period has not been paid.
     * There is a billing issue which requires action from the user to resolve.
     */
    BillingStatus["Unpaid"] = "Unpaid";
})(BillingStatus = exports.BillingStatus || (exports.BillingStatus = {}));
/**
 * The simplified status of a subscription we show to users, derived entirely
 * from the other subscription state fields.
 *
 * Important: The status isn't enough to represent every possible state of a
 * subscription. For example, a subscription can have a downgrade scheduled and
 * also require action as the user hasn't paid for the current billing period.
 */
var Status;
(function (Status) {
    /**
     * User has a valid/ active plan which has been paid for the current billing
     * period. If it is a stripe-managed plan, then it will renew at the end
     * of the current billing period.
     */
    Status["Active"] = "Active";
    /**
     * The plan is valid/ active but has been scheduled to downgrade to a lower
     * plan on renewal.
     */
    Status["DowngradeScheduled"] = "Downgrade Scheduled";
    /**
     * Plan is valid/ active but has been scheduled for cancellation at the
     * end of the billing period instead of being renewed.
     */
    Status["Cancelled"] = "Cancelled";
    /**
     * The user has an unpaid invoice for the current billing period.
     *
     * Important: A plan can also have a 'downgrade scheduled' or be 'cancelled'
     * while in this state, but the plan status will still be Requires Action as
     * it's the highest priority status.
     */
    Status["RequiresAction"] = "Requires Action";
    /**
     * The plan has now expired / terminated. The subscription is in a finalised
     * state which cannot be renewed.
     *
     * A plan can't be renewed, resumed, cancelled, or downgraded while in this
     * state.
     *
     * The user must purchase a new subscription to continue using the software.
     */
    Status["Expired"] = "Expired";
})(Status = exports.Status || (exports.Status = {}));
/**
 * Is the user entitled to use the subscription?
 */
var Entitlement;
(function (Entitlement) {
    /**
     * The plan is considered to be in good standing.
     * - the invoice has been paid for the current billing period.
     */
    Entitlement["Entitled"] = "Entitled";
    /**
     * The plan is not considered to be in good standing.
     * - the initial subscription payment has not been paid, or,
     * - the renewal invoice has not been paid, or,
     * - the subscription has been terminated.
     */
    Entitlement["Suspended"] = "Suspended";
})(Entitlement = exports.Entitlement || (exports.Entitlement = {}));
/**
 * What will happen to a subscription at the end of the current billing period.
 *
 * Manual subscriptions can only ever be in the Cancel or None state.
 */
var RenewalAction;
(function (RenewalAction) {
    /**
     * The subscription is scheduled to renew.
     */
    RenewalAction["Renew"] = "Renew";
    /**
     * The subscription is scheduled to downgrade the plan and renew on the new
     * downgraded plan.
     */
    RenewalAction["Downgrade"] = "Downgrade";
    /**
     * The subscription is scheduled to terminate (no renewal).
     *
     * A Manual subscription starts in this state.
     */
    RenewalAction["Cancel"] = "Cancel";
    /**
     * The subscription will never reach another renewal date.
     * e.g. the plan has already terminated.
     */
    RenewalAction["None"] = "None";
})(RenewalAction = exports.RenewalAction || (exports.RenewalAction = {}));
var SubscriptionType;
(function (SubscriptionType) {
    /**
     * Manually created subscription which will always terminate on the end date.
     */
    SubscriptionType["Manual"] = "Manual";
    /**
     * Stripe-managed subscription
     */
    SubscriptionType["Stripe"] = "Stripe";
})(SubscriptionType = exports.SubscriptionType || (exports.SubscriptionType = {}));
